/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { onboardingStepsSchema } from '../../account/enums/onboarding-steps-schema';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const preferenceSchema = z.object({
  id: z.number(),
  primaryLanguage: z.string().nullable(),
  detectiveMode: z.boolean(),
  proficiencyScore: z.number(),
  proficiencyUpdatedAt: z.number().nullable(),
  notificationEnabled: z.boolean(),
  reminderTimes: z.array(z.string()),
  timezone: z.string().nullable(),
  createdAt: z.number(),
  updatedAt: z.number(),
});

export const userAccountV1DataSchema = z.object({
  userId: z.string(),
  onboarding: onboardingStepsSchema.default({}),
  preference: preferenceSchema.nullable(),
});

export type IUserAccountV1Data = z.infer<typeof userAccountV1DataSchema>;
export type IUserAccountPreference = z.infer<typeof preferenceSchema>;

export const getUserAccountV1ResponseSchema = createApiResponseSchema(
  userAccountV1DataSchema,
) as z.ZodSchema<IAPI<IUserAccountV1Data>>;

export type IGetUserAccountV1Response = IAPI<IUserAccountV1Data>;
